<template>
  <div>
    <h4 class="text-center">Viber Business Messages</h4>

    <div class="mt-5">
      <form @submit.prevent="promiseConnect = connect()">
        <div class="form-group row">
          <label class="col-4 text-muted col-form-label">
            Choose a Sender ID:
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': isSenderIdInvalid || serverErrorMessage}"
                   placeholder="My Company"
                   v-model="senderId"
                   maxlength="50"/>
            <div v-show="isSenderIdInvalid" class="invalid-feedback">
              Please provide Sender ID.
            </div>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div>
          <b-button v-b-toggle.collapse-1
                    class="mt-4 pl-0"
                    variant="link"><icon class="btn-icon" name="question-circle" scale="1.0"></icon><span class="small">What is Sender ID?</span></b-button>

          <b-collapse id="collapse-1" class="mt-2">
            <b-card class="bg-light">
              <p class="m-2 text-muted">
                Sender ID is displayed in the Viber app as the sender of your messages.
                Please choose carefully. <b>Due to Viber policies, you won't be able to change it later.</b>
                See <a href="https://docs.amio.io/v1.0/docs/viber-getting-started-viber-business-messages-connect#section-what-is-sender-id" target="_blank">documentation</a> for more info.
              </p>

              <div class="d-flex">
                <img class="my-2 mx-auto" src="../../../../../assets/img/channel_wizard/viber_business_messages/mockup_viberbm_cutoff.png"/>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnect">
              Create
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/question-circle'

  export default {
    data() {
      return {
        promiseConnect: null,
        isSenderIdInvalid: false,
        senderId: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connect() {
        this.clearError()
        if (!this.senderId) {
          this.isSenderIdInvalid = true
          return
        }

        this.isSenderIdInvalid = false
        const data = {
          type: 'viber_business_messages',
          viber_business_messages: {
            sender_id: this.senderId
          }
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            return this.handleError(error)
          })
          .then(() => {
            this.promiseConnect = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
